import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteSavedPlaceList } from "common/apis/savedplaces";
import { Storage } from "common/storage";

export function usePostDeleteSavedList() {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = useQueryClient();

  const { mutate, data, error, status } = useMutation({
    mutationFn: ({ savedPlaceId }: { savedPlaceId: string }) => {
      return deleteSavedPlaceList(savedPlaceId, accessToken || "");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getAllSavedPlaces"],
        exact: false,
      });
    },
  });

  return {
    deleteList: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
